import { Link } from "react-router-dom";

/* Banner sottile: prova in corso (grigio) o pagamento fallito (rosso). Niente per account esterni/attivi. */
export default function TrialBanner({ user }) {
  const b = user?.billing;
  if (!b || user?.role === "admin") return null;
  if (b.mode === "trial" && !b.blocked) {
    const d = b.days_left;
    return (
      <div className="mb-4 flex flex-wrap items-center justify-between gap-2 rounded-lg border border-line bg-surface-2/60 px-4 py-2 text-xs text-slate-300" data-testid="trial-banner">
        <span>Prova gratuita · <strong className="tabular-nums text-slate-100">{d} {d === 1 ? "giorno rimasto" : "giorni rimasti"}</strong> con Ufficio completo</span>
        {!user?.team_role && <Link to="/impostazioni?s=plans" className="font-medium text-[#C5A059] hover:underline" data-testid="trial-banner-cta">Scegli il piano →</Link>}
      </div>
    );
  }
  if (b.status === "past_due" && !b.blocked) {
    return (
      <div className="mb-4 flex flex-wrap items-center justify-between gap-2 rounded-lg border border-red-500/40 bg-red-500/10 px-4 py-2 text-xs text-red-200" data-testid="pastdue-banner">
        <span>Pagamento non riuscito: aggiorna la carta entro il {new Date(b.grace_ends_at).toLocaleDateString("it-IT")} per evitare la sospensione.</span>
        {!user?.team_role && <Link to="/impostazioni?s=plans" className="font-medium text-red-100 underline" data-testid="pastdue-banner-cta">Aggiorna la carta</Link>}
      </div>
    );
  }
  return null;
}
